import _jsx from"@babel/runtime/helpers/esm/jsx";import React from'react';import PullToRefresh from'./pull_to_refresh';/**
 * Pullable:
 * Basic "pull to refresh" without the refresh.
 * Just visual feedback.
 */export default class Pullable extends React.Component{render(){const{children}=this.props;return/*#__PURE__*/_jsx(PullToRefresh,{pullingContent:null,refreshingContent:null},void 0,children);}}